(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.header details[open]').forEach(el=>{el.open=false;el.querySelector('summary')?.focus()})}});
document.addEventListener('click',event=>{document.querySelectorAll('.header details[open]').forEach(el=>{if(!el.contains(event.target))el.open=false})});
(() => {
  const header = document.querySelector('.header');
  if (!header) return;
  let previousY = window.scrollY;
  let downDistance = 0;
  let upDistance = 0;
  let framePending = false;
  window.addEventListener('scroll', () => {
    if (framePending) return;
    framePending = true;
    requestAnimationFrame(() => {
      framePending = false;
      const currentY = Math.max(0, window.scrollY);
      const delta = currentY - previousY;
      previousY = currentY;
      if (currentY < 64) {
        downDistance = 0;
        upDistance = 0;
        header.classList.remove('header--hidden');
      } else if (delta > 0) {
        downDistance += delta;
        upDistance = 0;
        if (downDistance > 8) {
          header.classList.add('header--hidden');
          downDistance = 0;
        }
      } else if (delta < 0) {
        upDistance -= delta;
        downDistance = 0;
        if (upDistance > 8) {
          header.classList.remove('header--hidden');
          upDistance = 0;
        }
      }
    });
  }, { passive: true });
})();
(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const backdrop = document.querySelector('[data-cart-backdrop]');
  const trigger = document.querySelector('[data-cart-open]');
  if (!drawer || !backdrop || !trigger) return;
  const itemsNode = drawer.querySelector('[data-cart-drawer-items]');
  const emptyNode = drawer.querySelector('[data-cart-empty]');
  const summaryNode = drawer.querySelector('[data-cart-summary]');
  let closeTimer;

  function money(cents, currency) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100); }
    catch { return `${(cents / 100).toFixed(2)} ${currency || ''}`.trim(); }
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = cart.item_count);
    drawer.querySelector('[data-drawer-count]').textContent = `(${cart.item_count})`;
    itemsNode.replaceChildren();
    emptyNode.hidden = cart.item_count > 0;
    summaryNode.hidden = cart.item_count === 0;
    if (cart.item_count === 0) return;

    const currency = cart.currency || '{{ cart.currency.iso_code }}';
    cart.items.forEach(item => {
      const row = document.createElement('article');
      row.className = 'cart-drawer-item';
      if (item.image) {
        const imageLink = document.createElement('a');
        imageLink.className = 'cart-drawer-image';
        imageLink.href = item.url;
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = item.product_title || item.title;
        image.loading = 'lazy';
        imageLink.append(image);
        row.append(imageLink);
      }
      const details = document.createElement('div');
      details.className = 'cart-drawer-item-details';
      const title = document.createElement('a');
      title.className = 'cart-drawer-item-title';
      title.href = item.url;
      title.textContent = item.product_title || item.title;
      details.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') {
        const variant = document.createElement('p');
        variant.className = 'cart-drawer-variant';
        variant.textContent = item.variant_title;
        details.append(variant);
      }
      const line = document.createElement('div');
      line.className = 'cart-drawer-line';
      const quantity = document.createElement('span');
      quantity.textContent = `Qty ${item.quantity}`;
      const price = document.createElement('strong');
      price.textContent = money(item.final_line_price ?? item.line_price, currency);
      line.append(quantity, price);
      details.append(line);
      row.append(details);
      itemsNode.append(row);
    });
    drawer.querySelector('[data-cart-subtotal]').textContent = money(cart.items_subtotal_price ?? cart.total_price, currency);
  }

  function closeDrawer() {
    if (drawer.hidden) return;
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('cart-drawer-open');
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => { drawer.hidden = true; backdrop.hidden = true; }, 260);
    trigger.focus();
  }

  async function openDrawer() {
    clearTimeout(closeTimer);
    drawer.hidden = false;
    backdrop.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('cart-drawer-open');
    requestAnimationFrame(() => { drawer.classList.add('is-open'); backdrop.classList.add('is-open'); });
    drawer.querySelector('[data-cart-close]').focus();
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Could not load cart');
      renderCart(await response.json());
    } catch {
      itemsNode.replaceChildren();
      emptyNode.hidden = false;
      emptyNode.textContent = 'Your bag could not be loaded. Please try again.';
      summaryNode.hidden = true;
    }
  }

  trigger.addEventListener('click', openDrawer);
  drawer.querySelector('[data-cart-close]').addEventListener('click', closeDrawer);
  drawer.querySelector('[data-cart-continue]').addEventListener('click', closeDrawer);
  backdrop.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeDrawer(); });
  document.addEventListener('cart:updated', event => { if (event.detail) renderCart(event.detail); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
function showProductMedia(gallery, mediaId) {
  if (!gallery || !mediaId) return;
  const main = gallery.querySelector('.product-gallery-main');
  const current = main.querySelector('.product-media:not([hidden])');
  const next = [...main.querySelectorAll('.product-media')].find(media => media.dataset.mediaId === String(mediaId));
  if (!current || !next || current === next) return;
  current.hidden = true;
  next.hidden = false;
  gallery.querySelectorAll('[data-gallery-thumb]').forEach(button => {
    button.setAttribute('aria-pressed', String(button.dataset.mediaId === next.dataset.mediaId));
  });
}
document.addEventListener('click', event => {
  const thumb = event.target.closest('[data-gallery-thumb]');
  if (thumb) showProductMedia(thumb.closest('.product-gallery'), thumb.dataset.mediaId);
});
document.addEventListener('pointermove', event => {
  if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
  const main = event.target.closest('.product-gallery-main');
  if (!main || !main.querySelector('.product-media--image:not([hidden])')) return;
  const bounds = main.getBoundingClientRect();
  const x = Math.max(0, Math.min(100, (event.clientX - bounds.left) / bounds.width * 100));
  const y = Math.max(0, Math.min(100, (event.clientY - bounds.top) / bounds.height * 100));
  main.style.setProperty('--zoom-x', `${x}%`);
  main.style.setProperty('--zoom-y', `${y}%`);
});
document.addEventListener('pointerout', event => {
  const main = event.target.closest('.product-gallery-main');
  if (main && !main.contains(event.relatedTarget)) {
    main.style.removeProperty('--zoom-x');
    main.style.removeProperty('--zoom-y');
  }
});
document.addEventListener('change', event => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const section = select.closest('[data-product-section]');
  const option = select.selectedOptions[0];
  const price = section.querySelector('[data-product-price]');
  const button = section.querySelector('[data-add-button]');
  const label = section.querySelector('[data-add-label]');
  const quantity = section.querySelector('[data-quantity]');
  const sku = section.querySelector('[data-product-sku]');
  price.innerHTML = `<span class="price">${option.dataset.price}${option.dataset.compare ? ` <s>${option.dataset.compare}</s>` : ''}</span>`;
  const available = option.dataset.available === 'true';
  button.disabled = !available;
  label.textContent = available ? section.dataset.labelAdd : section.dataset.labelSold;
  quantity.min = option.dataset.min || 1;
  quantity.step = option.dataset.step || 1;
  if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
  if (Number(quantity.value) < Number(quantity.min)) quantity.value = quantity.min;
  if (sku) sku.textContent = option.dataset.sku || '';
  showProductMedia(section.querySelector('.product-gallery'), option.dataset.mediaId);
  const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
});
document.addEventListener('submit', async event => {
  const form = event.target.closest('[data-product-form]'); if (!form || !window.fetch) return;
  event.preventDefault();
  const button=form.querySelector('[data-add-button]'),label=form.querySelector('[data-add-label]'),status=form.querySelector('[data-form-status]'),original=label.textContent;
  const section=form.closest('[data-product-section]');button.disabled=true; label.textContent=section.dataset.labelAdding; status.textContent='';
  try {const response=await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`,{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});const result=await response.json();if(!response.ok)throw new Error(result.description||result.message||section.dataset.labelError);const cart=await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then(res=>res.json());document.querySelectorAll('[data-cart-count]').forEach(node=>node.textContent=cart.item_count);document.dispatchEvent(new CustomEvent('cart:updated',{detail:cart}));status.textContent=section.dataset.labelAdded;label.textContent=original;}catch(error){status.textContent=error.message;label.textContent=original;}finally{button.disabled=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('product-recommendations[data-url]').forEach(async element=>{if(element.dataset.loaded)return;element.dataset.loaded='true';try{const response=await fetch(element.dataset.url);if(!response.ok)return;const html=await response.text();const parsed=new DOMParser().parseFromString(html,'text/html').querySelector('product-recommendations');if(parsed?.innerHTML.trim())element.innerHTML=parsed.innerHTML;}catch(error){}});

  } catch(e) { console.error(e); }
})();
})();
